export default __webpack_public_path__ + "static/media/sprite-side-effects.1911ee15.png";